import { client } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = (params) =>
  client.executeRequest('GET', `/processingwindows`, {
    queryParams: { ...params },
    returnModel: { name: 'processingwindows' },
  });
